import { AuthService } from '../auth/auth.service';
import { AuthState } from '@app/enums/auth-state.enum';
import { Injectable, inject } from '@angular/core';
import { StorageService } from '../storage/storage.service';

@Injectable({
    providedIn: 'root'
})
export class ClearSessionService {
    private readonly authService: AuthService = inject(AuthService);
    private readonly storageService: StorageService = inject(StorageService);

    public initialize(): void {
        console.log('🚀 ~ ClearSessionService ~ initialize ~ initialize:');
        this.authService.authState.pipe().subscribe((state: AuthState) => {
            if (state === AuthState.IsNotAuthenticated) {
                this.storageService.clear();
            }
        });
    }
}
